import React, { lazy } from 'react';
import { string, func } from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';
import { downloadFile } from 'Helpers/utils';
import useAuth from 'Hooks/useAuth';
import { FILE_API_URL } from 'Constants/apis';
import Loading from 'Modules/Loading';
// import PdfViewer from './PdfViewer';

const PdfViewer = lazy(() => import('./PdfViewer'));

const PDFViewModal = ({ fileId, onClose, fileName, extraAction }) => {
  const { token } = useAuth();

  const onDownload = () => {
    downloadFile(`${FILE_API_URL}/files/${fileId}`, token, fileName);
  };

  return (
    <Modal open onClose={onClose} closeIcon style={{ width: 675 }}>
      <Modal.Content scrolling style={{ width: 675, height: 1920 }}>
        <React.Suspense fallback={<Loading />}>
          <PdfViewer fileID={fileId} />
        </React.Suspense>
      </Modal.Content>
      <Modal.Actions>
        {extraAction}
        <Button content="Download" primary onClick={onDownload} />
      </Modal.Actions>
    </Modal>
  );
};

PDFViewModal.propTypes = {
  fileId: string.isRequired,
  fileName: string,
  onClose: func.isRequired,
  extraAction: React.node,
};

PDFViewModal.defaultProps = {
  fileName: 'Memo.pdf',
  extraAction: '',
};

export default PDFViewModal;
